import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import API from "../api";
import Swal from "sweetalert2";
import "./QuestionsScreen.css";

const QuestionsScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const {
        module_id,
        section_id,
        screen_id = 1,
        screenCounter = 1,
        sectionCounter,
        scorePerQuestion,
        maxScreen,
        numberOfTrys
    } = location.state;

    const { score } = location.state || {};
    const { moduleScore = 0 } = location.state;

    const [data, setData] = useState([]);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [correct, setCorrect] = useState(false);
    const [timer, setTimer] = useState(20);
    const [stopTime, setStopTime] = useState(false);
    const [maxSectionsNum, setMaxSectionsNum] = useState();

    const rawUserId = localStorage.getItem("userId");
    const userId = rawUserId && rawUserId !== "null" ? parseInt(rawUserId, 10) : null;

    // --- FETCH USER SCORE ---
    const fetchUserScore = async () => {
        if (!userId) return 0;

        try {
            const scoreResponse = await API.get(`/module/score/${userId}`);
            return scoreResponse.data[0]?.score || 0;
        } catch (error) {
            console.error("Greška pri dohvaćanju score-a:", error);
            return 0;
        }
    };

    // --- FETCH QUESTIONS ---
    useEffect(() => {
        API.get(`module/answeres/${module_id}/${section_id}`).then(response => {
            setData(response.data);
        });

        API.get(`module/getMaxNumOfSections/${module_id}`).then(response => {
            setMaxSectionsNum(response.data);
        });
    }, [module_id, section_id]);

    // --- TIMER LOGIC ---
    useEffect(() => {
        if (!stopTime && timer > 0) {
            const interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);

            return () => clearInterval(interval);
        } else if (timer === 0) {
            handleTimeOut();
        }
    }, [timer, stopTime]);

    // --- ROUTE MAP ---
    const getModuleRoute = () => {
        switch (module_id) {
            case 4: return "/email-next-screen";
            case 5: return "/password-security-next-screen";
            case 6: return "/malware-next-screen";
            case 7: return "/social-networks-next-screen"
            default: return "/email-next-screen";
        }
    };

    // --- TIMEOUT → RESET SECTION ---
    const handleTimeOut = async () => {
        setStopTime(true);

        const currentScore = await fetchUserScore();

        Swal.fire({
            title: "Vrijeme je isteklo!",
            text: "Vraćamo vas na početak sekcije.",
            icon: "error",
            confirmButtonText: "OK",
            background: "#1d203ee6",
            color: "#F5F5F5",
            confirmButtonColor: "#E31298"
        }).then(() => {
            navigate(getModuleRoute(), {
                state: {
                    module_id,
                    section_id,
                    screen_id: screen_id - (maxScreen - 1),
                    screenCounter: 1,
                    sectionCounter,
                    scorePerQuestion,
                    maxScreen,
                    maxSectionsNum,
                    numberOfTrys: numberOfTrys + 1,
                    moduleScore
                }
            });
        });
    };

    const handleAnswerSelect = (answerIndex, isCorrect) => {
        setSelectedAnswer(answerIndex);
        setCorrect(isCorrect);
    };

    // --- MAIN ANSWER LOGIC ---
    const answerQuestion = async () => {
        let updatedScore = moduleScore || 0;
        let recivedScore = 0;

        const scorePerQuestionValue = scorePerQuestion || 250;

        if (correct) {
            setStopTime(true);

            // --- SCORE PENALTY FORMULA ---
            if (timer >= 13) {
                recivedScore = Math.floor(scorePerQuestionValue - ((numberOfTrys * 10 / 100) * scorePerQuestionValue));
            } else if (timer > 5 && timer < 13) {
                recivedScore = Math.floor((scorePerQuestionValue / 2) - ((numberOfTrys * 10 / 100) * scorePerQuestionValue));
            } else {
                recivedScore = Math.floor((scorePerQuestionValue / 4) - ((numberOfTrys * 10 / 100) * scorePerQuestionValue));
            }

            recivedScore = Math.max(0, recivedScore);
            updatedScore += recivedScore;
            console.log("Received score: ", recivedScore);
            console.log("Novi broj bodova:", updatedScore);

            Swal.fire({
                title: "Odgovor je tačan!",
                icon: "success",
                confirmButtonText: "Continue",
                background: "#1d203ee6",
                color: "#F5F5F5",
                confirmButtonColor: "#E31298"
            }).then(() => {
                navigate("/results", {
                    state: {
                        module_id,
                        section_id: section_id + 1,
                        screen_id: screen_id + 1,
                        screenCounter: 1,
                        sectionCounter: sectionCounter + 1,
                        scorePerQuestion: scorePerQuestionValue,
                        recivedScore: recivedScore,
                        numberOfTrys: 0,
                        score: updatedScore,
                        moduleScore: updatedScore     // ✅ OVO JE PRAVO
                    }
                });
            });

        } else {
            // --- WRONG ANSWER → RESET SECTION + PENALTY ---
            setStopTime(true);

            const currentScore = await fetchUserScore();

            Swal.fire({
                title: "Odgovor je netačan!",
                text: "Pokušajte ponovo.",
                icon: "error",
                confirmButtonText: "OK",
                background: "#1d203ee6",
                color: "#F5F5F5",
                confirmButtonColor: "#E31298"
            }).then(() => {
                navigate(getModuleRoute(), {
                    state: {
                        module_id,
                        section_id,
                        screen_id: screen_id - (maxScreen - 1),
                        screenCounter: 1,
                        sectionCounter,
                        scorePerQuestion: scorePerQuestionValue,
                        maxScreen,
                        numberOfTrys: numberOfTrys + 1,
                        moduleScore
                    }
                });
            });
        }
    };

    return (
        <div className="questions-container">
            <div className="question-card">
                <h2 className="question-title">Training Module: Q & A</h2>
                <p
                    className="question-text"
                    dangerouslySetInnerHTML={{
                        __html: data.length > 0
                            ? data[0].question.replace(/\n/g, "<br />")
                            : "Učitavanje pitanja..."
                    }}
                />

                <div className="answers-container">
                    {data.map((ans, index) => (
                        <label key={index} className="answer-option">
                            <input type="checkbox"
                                checked={selectedAnswer === index}
                                onChange={() => handleAnswerSelect(index, ans.is_corrects)}
                            />
                            <span className="answer-text">{ans.answer}</span>
                        </label>
                    ))}
                </div>

                <div className="timer-container">
                    <span>Preostalo vrijeme: </span>
                    <span className={`timer-text ${timer <= 10 ? "red" : ""}`}>
                        {timer}''
                    </span>
                </div>

                <button className="confirm-button" onClick={answerQuestion}>
                    CONFIRM
                </button>
            </div>
        </div>
    );
};

export default QuestionsScreen;